import { AfterContentInit, Component, ContentChildren, ElementRef, OnInit, OnDestroy, QueryList, TemplateRef, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { UsersService } from '../../services/users.service';
import { DefaultValueConstants } from '../../constants/default-value-constants';
import { SpinnerService, SpinnerState } from '../../services/spinner.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { VersionService } from '../../services/version.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, AfterContentInit, OnDestroy {
  @ContentChildren(TemplateRef) middlebarTemplate!: QueryList<TemplateRef<any>>;
  @ViewChild('footerRef', { static: false }) footerRef!: ElementRef;
  showContentInMenu = true;
  showCurrentLocation = true;
  labsiteName = '';  
  isLIMSHosted = false;
  showSpinner: boolean = false;
  spinnerMessage: string = '';
  private destroy$ = new Subject<void>();
  app = (window as any).app;

  menuItems: MenuItem[] = [
    {
      label:'My Space',
      icon: 'fa-solid fa-house-chimney',
      items:[
        {
          label: 'Home',
          routerLink: '/my-space/eqms.home',
          icon: 'fa-solid fa-house-chimney'
        },
        {
          label: 'User Profile',
          routerLink: '/my-space/eqms.user-profile',
          icon: 'fa-solid fa-user'
        }
      ]
    },  
    {
      label: 'Queues',
      icon: 'fas fa-list-ul',
      items: [
        {
          label: 'My Favorites',
          routerLink: 'eqms.my-favorites',
          icon: 'fas fa-star'
        },
        {
          label: 'My Assigned Admin',
          routerLink: 'eqms.my-assign-admin',
          icon: 'fas fa-regular fa-clipboard'
        },
        {
          label: 'My Doc Collabs',
          routerLink: 'eqms.my-doc-collabs',
          icon: 'fas fa-solid fa-users'
        },
        {
          label: 'My QA Reviews',
          routerLink: 'eqms.my-qa-reviews',
          icon: 'fas fa-compass-drafting'
        },
        {
          label: 'My Doc Formattings',
          routerLink: 'eqms.my-doc-formattings',
          icon: 'fas fa-solid fa-pen-to-square'
        },
        {
          label: 'My Client Signatures',
          routerLink: 'eqms.my-client-signatures',
          icon: 'fa-solid fa-file-signature'
        },
        {
          label: 'My Doc Reviews',
          routerLink: 'eqms.my-doc-review',
          icon: 'fas fa-eye'
        },
        {
          label: 'My Doc Approvals',
          routerLink: 'eqms.my-doc-approvals',
          icon: 'far fa-check-circle'
        },
        {
          label: 'My Change Requests',
          routerLink: 'eqms.my-change-requests',
          icon: 'fas fa-lightbulb'
        },
        {
          label: 'My Hardcopy Activities',
          routerLink: 'eqms.myhard-copy',
          icon: 'fas fa-solid fa-print'
        },
        {
          label: 'Delegation',
          routerLink: 'eqms.delegate',
          icon: 'fas fa-share'
        },
        {
          label: 'My Quarantined Documents',
          routerLink: 'eqms.my-quarantined-documents',
          icon: 'fas fa-file-shield'
        },
        {
          label: 'My Skill Acknowledgements',
          routerLink: 'eqms.my-skill-acknowledgements',
          icon: 'fas fa-solid fa-award'
        },
        {
          label: 'My Skill Verifications',
          routerLink: 'eqms.my-skill-verifications',
          icon: 'far fa-check-circle'
        }
      ]
    },
    {
      label: 'Doc Control',
      icon: 'fas fa-file-alt',
      items: [
        {
          label: 'Document Library',
          routerLink: '/eqms.document',
          routerLinkActiveOptions: "active",
          icon: 'fas fa-search'
        },
        {
          label: 'Document Template',
          routerLink: "/eqms.documentTemplatesManagement",
          icon: 'fas fa-list-ul'
        }
      ]

    },
    {
      label: 'Training',
      icon:'fas fa-graduation-cap pr-4',
      items:[
        {
          label:'Course Catalogue',
          routerLink:'eqms.course',
          icon:'fas fa-magnifying-glass'
        },
        {
          label:'Training Item Group',
          routerLink:'eqms.training-item',
          icon:'fas fa-object-group'
        },
        {
          label:'Curriculum',
          routerLink:'eqms.curriculum',
          icon:'fas fa-building-columns'
        },
        {
          label:'Skill Search',
          routerLink:'eqms.skill',
          icon:'fas fa-award'
        }
      ]
    },
    {
      label:'Change Management',
      icon: 'fa-solid fa-square-pen',
      items:[
        {
          label: 'Change Register',
          routerLink: '/eqms.change-control',
          icon: 'fas fa-search'
        },
        {
          label: 'Action Item Register',
          routerLink: '/eqms.action-item-register',
          icon: 'fas fa-search'
        }        
      ]
    },
    {
      label: 'Reporting',
      icon: 'fa-solid fa-chart-column',
      items: [
        {
          label: 'Training Status',
          routerLink: '/eqms.training-status',
          icon: 'fa-solid fa-chart-column'
        } 
      ]
    },
    {
      label: 'System Admin',
      icon: 'fas fa-user-cog pr-4',
      items: [
        {
          label: 'eQMS Scope',
          routerLink: "/eqms.eqmsScopeManagement",
          icon: 'fas fa-toolbox'
        },
        {
          label: 'Assignment Group',
          routerLink: "eqms.assignment-group",
          icon: 'fas fa-users-gear'
        },       
        {
          label: 'User Select',
          routerLink: "/eqms.userSelection",
          icon: 'fas fa-user-cog'
        },
      ]
    }, 
    {
      icon: 'fa-solid fa-robot pr-4',
      routerLink: '/eqms.record-kpr'
    }
  ];

  constructor(
    private usersService: UsersService,
    private elementRef: ElementRef,
    private spinner: SpinnerService
  ) {
    if((window as any).app!)
    this.isLIMSHosted = typeof((window as any).app.appVersion) !== "undefined";
  }

  ngAfterContentInit() {
    const footerElement: HTMLElement | null = this.elementRef.nativeElement.querySelector('bpt-footer');

    if (footerElement) {
      footerElement.innerText = DefaultValueConstants.eQMS_Footer;
    }
  }

  ngOnInit(): void {
   this.spinner.getSpinnerState()
    .pipe(takeUntil(this.destroy$))
    .subscribe((state) => {
      this.showSpinner = state.isLoading;
      this.spinnerMessage = state.message || '';
    });

    this.usersService.menuItems = this.menuItems;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
